import React from 'react';
import { FadeIn } from './FadeIn';
import { Mail } from 'lucide-react';
export function Contact() {
  return <section className="py-20 md:py-32 px-6 relative overflow-hidden" data-id="element-15">
      {/* Decorative background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-amber/5 rounded-full blur-3xl -z-10" data-id="element-16" />

      <div className="max-w-2xl mx-auto text-center" data-id="element-17">
        <FadeIn data-id="element-18">
          <span className="text-sage font-medium tracking-widest uppercase text-xs md:text-sm mb-4 block" data-id="element-19">
            What's Next?
          </span>
          <h2 className="font-playfair text-4xl md:text-6xl text-charcoal mb-6 md:mb-8" data-id="element-20">
            Let's Connect
          </h2>

          <p className="text-base md:text-lg text-charcoal/70 font-light mb-8 md:mb-10 leading-relaxed" data-id="element-21">
            I'm looking for paralegal or legal assistant roles as I wrap up the
            UCLA program. If you've got an opening, know someone who does, or
            just want to chat, drop me a line.
          </p>

          <a href="mailto:jacobpalkin@gmail.com" className="inline-flex items-center gap-3 bg-charcoal text-cream px-7 md:px-8 py-3.5 md:py-4 rounded-full text-base md:text-lg hover:bg-amber transition-colors duration-300 mb-6" data-id="element-22">
            <Mail size={20} data-id="element-23" />
            Say Hello
          </a>

          <p className="text-charcoal/50 text-sm font-light italic tracking-wide" data-id="element-24">
            References available upon request.
          </p>
        </FadeIn>
      </div>
    </section>;
}